import axios from 'axios'
import config from '../assets/js/handle-config.js'
import { setSharedToken, removeSharedToken } from '../assets/js/shared-token.js'

export default {
  setMenuStartTime ({commit}, value) {
    commit('SET_MENU_START_TIME', value)
  },
  setMenuEndTime ({commit}, value) {
    commit('SET_MENU_END_TIME', value)
  },
  setUserInfo ({commit}, {userId, token, roleType, account}) {
    commit('SET_TOKEN', token)
    commit('SET_USER_ID', userId)
    commit('SET_ROLE_TYPE', roleType)
    commit('SET_ACCOUNT', account)
    setSharedToken(token)
  },
  setRestrictList ({commit}, restrict) {
    commit('SET_RESTRICT', restrict)
  },
  setTradeTypeList ({commit}, value) {
    commit('SET_TRADE_TPYE', value)
  },
  setToken ({commit}, value) {
    commit('SET_TOKEN', value)
    setSharedToken(value)
  },
  // checkToken 失敗的訊息
  setAuthError ({commit}, value) {
    commit('SET_AUTH_ERROR', value)
  },
  // 登出：vuex、localStorage、共用 cookie 一次清乾淨
  clearUserInfo ({commit}) {
    commit('SET_TOKEN', '')
    commit('SET_USER_ID', '')
    commit('SET_ROLE_TYPE', '')
    commit('SET_ACCOUNT', '')
    commit('SET_AUTH_ERROR', '')
    window.localStorage.removeItem(config.token)
    window.localStorage.removeItem(config.userId)
    window.localStorage.removeItem(config.roleType)
    window.localStorage.removeItem(config.account)
    removeSharedToken()
  },
  setUpCategory ({commit}, value) {
    commit('SET_UP_CATEGORY', value)
  },
  setUpAdjust ({commit}, value) {
    commit('SET_UP_ADJUST', value)
  },
  setModal ({commit}, value) {
    commit('SET_MODAL', value)
  },
  // in lineNotifyTable
  setSelManagerId ({commit}, value) {
    commit('SET_SEL_MANAGER_ID', value)
  },
  setSelRoleType ({commit}, value) {
    commit('SET_SEL_ROLE_TYPE', value)
  },
  setModalView ({commit}, value) {
    commit('SET_MODAL_VIEW', value)
  },
  setBrandId ({commit}, value) {
    commit('SET_BRAND_ID', value)
  },
  setStoreId ({commit}, value) {
    commit('SET_STORE_ID', value)
  },
  setBrands ({commit}, value) {
    commit('SET_BRANDS', value)
  },
  setStores ({commit}, value) {
    commit('SET_STORES', value)
  },
  setBlackReason ({commit}, value) {
    commit('SET_BLACK_REASON', value)
  },
  setUnReadNotify ({commit}, value) {
    commit('SET_UNREAD_NOTIFY', value)
  },
  setCityList ({commit}) {
    // 取得縣市名稱與 code 列表
    axios({
      baseURL: config.baseURL,
      method: 'get',
      url: '/platform/cityAreaList',
      data: null
    })
    .then((response) => {
      commit('SET_CITY_LIST', response.data.list)
    })
    .catch(error => {
      console.error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js